import AppSidebar from './common/AppSidebar';
import AppHeader from './common/AppHeader';
import AppTitle from './common/AppTitle';
import useFetchData from './helpers/useFetch';
import AppURL from './constants/AppURL';
import AppRoutes from './routes/AppRoutes';
import Watermarks from './constants/Watermarks';
import FixedSearchBox from './constants/FixedSearchBar';
import SearchMemberListView from './constants/SearchMemberList';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { CURRENT_FISCAL_YEAR_REDUCER, setFullDetailsData } from './store/orgSlice';

const DefaultLayouts = () => {
  const [onIcons, setIconsButton] = useState("");
  const [openSearch, setOpenSearch] = useState<boolean>(false);
  const dispatch = useDispatch();
  const { data, loading, error } = useFetchData(AppURL.ApplicationURL + 'app/menu/details/view/'); // Pass only the URL
  useEffect(() => {
    dispatch(setFullDetailsData(data || []));
    if (data && data.fiscal_year) {
      dispatch(CURRENT_FISCAL_YEAR_REDUCER(data?.fiscal_year));
    } else {
      console.log('Fiscal year data is missing from the API response.');
    }
  }, [data, dispatch]);


  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  return (
    <div className="dark:bg-box dark-2 dark:text-bodydark">
      <div className="flex h-screen bg-slate-100 dark:bg-sky_850 overflow-hidden">
        <AppSidebar data={data.data} />
        <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
          <AppHeader data={data} />
          <AppTitle onIcons={onIcons} />
          <main>
            <Watermarks>
              <div className="mx-auto px-4 pb-5 pt-4 md:pb-5 md:pt-4 2xl:pb-5 2xl:pt-4">
                <AppRoutes data={data?.data} setIconsButton={setIconsButton} />
              </div>
            </Watermarks>
          </main>
        </div>
        {/* <FixedBox /> */}
        {/* <RotateBox /> */}
        <FixedSearchBox onClick={() => setOpenSearch(true)} />
        <SearchMemberListView openSearch={openSearch} setOpenSearch={setOpenSearch} />
      </div>
    </div>
  )
}

export default DefaultLayouts
